<template>
    <el-dialog v-if="dialogVisible" class="affirmDialog" title="批量上传" :visible.sync="dialogVisible">
        <!-- 选择上传文件 -->        
        <simple-uploader ref="batch"  source="batch" @onSuccess="handleSuccess"  @onRemove="handleRemove" style="width:100%"></simple-uploader>

        <div class="desc">提示：需要严格按照模板进行上传，支持excel格式</div>
        <a :href="`${publicPath}外包管理上传模板.xlsx`" class="download">下载模板 <i class="el-icon-arrow-right"></i></a>
        <!-- 底部按钮 -->
        <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" plain @click="dialogVisible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="handleVisible">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import SimpleUploader from '../../materialCenter/components/simpleUploader.vue'
export default {
    components:{SimpleUploader},
    props: {
        // 来源
        source: {
            type: String,
            default: ''
        },
    },

    data() {
        return{
            publicPath: process.env.BASE_URL,
            dialogVisible: false,

        }
    },

    methods: {
        // 初始化
        init() {
            this.dialogVisible = true
        },

        // 确定
        handleVisible() {
            this.dialogVisible = false
        },

        // 上传成功
        handleSuccess() {

        },

        // 已上传 删除
        handleRemove() {
            
        }
    }

}
</script>

<style lang="scss" scoped>
    .affirmDialog{
        .desc{
           margin: 16px 0;
           color: #999999;
           line-height: 20px;
        }
        .download{
            color: #3A89FF;
            line-height: 14px;
        }

        ::v-deep .el-dialog{
            width: 428px;
            min-height: 286px;
            background: #FFFFFF;
            border-radius: 4px;
            top: 50%;
            margin-top: 0 !important;
            transform:translateY(-50%);
        }

        ::v-deep.el-dialog__header{
            height: 68px;
            padding: 0 32px;
            line-height: 68px;

            .el-dialog__title{
                font-weight: 500;
                color: #333333;
            }
        }

        ::v-deep .el-dialog__close{
            font-size: 28px;
            color:#999999;
        }

        ::v-deep .el-dialog__body{
            padding: 16px 24px;
        }


        ::v-deep .el-dialog__footer{
            padding:24px 24px;
            // position:absolute;
            // right: 32px;
            // bottom: 24px;
        }

        .el-button--primary.is-plain{
            border: 1px solid #3A89FF;
            background: #FFFFFF;
            color: #3A89FF;
        }

        ::v-deep.el-button{
            padding:10px 15px;
            font-size: 14px;
        }
    }
</style>
